import type { CSSProperties } from "react";

import type { Addendum, NoteType } from "@/core/types";

import { AcaAddendumDisplay } from "./(advanced-care)/AcaAddendumDisplay";
import { GeneralAddendumDisplay } from "./(general)/GeneralAddendumDisplay";

type AddendumDisplayProps = {
  addendum: Addendum;
  noteType?: NoteType | null;
  style?: CSSProperties;
  textTestId?: string;
};

// Only file in the feature allowed to know both (general) and (acaa) exist —
// composes the ACAA screening block into the general display via its
// children slot, so callers never branch on it themselves.
export function AddendumDisplay({ addendum, noteType, style, textTestId }: AddendumDisplayProps) {
  return (
    <GeneralAddendumDisplay addendum={addendum} style={style} textTestId={textTestId}>
      {noteType === "Advanced Care Activity" && (
        <AcaAddendumDisplay additionalContent={addendum.additional_content} />
      )}
    </GeneralAddendumDisplay>
  );
}
